const NotFound = () => {
  return (
    <main className="not-found-page">
      <h2>Page Not Found</h2>
      <p>
        We're sorry, the page you're looking for could not be found.
      </p>
    </main>
  );
};

export default NotFound;
